const queryPropertyArea = r => require.ensure([], () => r(require('@/page/propertyAreaMge/queryPropertyArea/queryPropertyArea')), 'queryPropertyArea');
const addVillagesInCities = r => require.ensure([], () => r(require('@/page/propertyAreaMge/queryPropertyArea/addVillagesInCities')), 'addVillagesInCities');
const detailProoertyArea = r => require.ensure([], () => r(require('@/page/propertyAreaMge/queryPropertyArea/detailProoertyArea')), 'detailProoertyArea');
const addOrEditOrgProject = r => require.ensure([], () => r(require('@/page/propertyAreaMge/addOrEditOrgProject/addOrEditOrgProject')), 'addOrEditOrgProject');
const editOrEditOrgProject = r => require.ensure([], () => r(require('@/page/propertyAreaMge/addOrEditOrgProject/editOrEditOrgProject')), 'editOrEditOrgProject');
const addCompanyProperty = r => require.ensure([], () => r(require('@/page/propertyAreaMge/addOrEditOrgProject/addCompanyProperty')), 'addCompanyProperty');
const companyList = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/projectCaseList/companyList')), 'companyList');
const propertyProjectList = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/projectCaseList/propertyProjectList')), 'propertyProjectList');
const deletedPropertyArea = r => require.ensure([], () => r(require('@/page/propertyAreaMge/deletedPropertyArea/deletedPropertyArea')), 'deletedPropertyArea');
const deleteProject = r => require.ensure([], () => r(require('@/page/propertyAreaMge/deletedPropertyArea/deleteProject')), 'deleteProject');
const deletedPropertyAreaSee = r => require.ensure([], () => r(require('@/page/propertyAreaMge/deletedPropertyArea/deletedPropertyAreaSee')), 'deletedPropertyAreaSee');
const projectAppMieShi = r => require.ensure([], () => r(require('@/page/propertyAreaMge/deletedPropertyArea/projectAppMieShi')), 'projectAppMieShi');
const propertyAreaMge = r => require.ensure([], () => r(require('@/page/propertyAreaMge/propertyAreaMge')), 'propertyAreaMge');
const propertyInfo = r => require.ensure([], () => r(require('@/page/propertyAreaMge/propertyInfo/propertyInfo')), 'propertyInfo');
const addPropertyArea = r => require.ensure([], () => r(require('@/page/propertyAreaMge/addPropertyArea/addPropertyArea')), 'addPropertyArea');
const editPropertyArea = r => require.ensure([], () => r(require('@/page/propertyAreaMge/editPropertyArea/editPropertyArea')), 'editPropertyArea');
const propertyAreaInfo = r => require.ensure([], () => r(require('@/page/propertyAreaMge/propertyInfo/propertyAreaInfo/propertyAreaInfo')), 'propertyAreaInfo');
const add = r => require.ensure([], () => r(require('@/page/propertyAreaMge/propertyInfo/ProjectPractitioner/add')), 'add');
const houseChange = r => require.ensure([], () => r(require('@/page/propertyAreaMge/houseChange/houseChange')), 'houseChange');
const houseSplMer = r => require.ensure([], () => r(require('@/page/propertyAreaMge/houseSplMer/houseSplMer')), 'houseSplMer');
const propertyRegColl = r => require.ensure([], () => r(require('@/page/propertyAreaMge/propertyRegColl/propertyRegColl')), 'propertyRegColl');
const housManage = r => require.ensure([], () => r(require('@/page/housManage/housManagePage/housManage')), 'housManage');
const queryOwnerMge = r => require.ensure([], () => r(require('@/page/ownerMge/queryOwnerMge/queryOwnerMge')), 'queryOwnerMge');
const housManageAdd = r => require.ensure([], () => r(require('@/page/housManage/housManageAdd/housManageAdd')), 'housManageAdd');
const housManageEdit = r => require.ensure([], () => r(require('@/page/housManage/housManageEdit/housManageEdit')), 'housManageEdit');
const buildingList = r => require.ensure([], () => r(require('@/page/propertyAreaMge/buildingMge/buildingList/buildingList')), 'buildingList');
const addBuilding = r => require.ensure([], () => r(require('@/page/propertyAreaMge/buildingMge/addBuilding/addBuilding')), 'addBuilding');
const editBuilding = r => require.ensure([], () => r(require('@/page/propertyAreaMge/buildingMge/editBuilding/editBuilding')), 'editBuilding');
const buildDetail = r => require.ensure([], () => r(require('@/page/propertyAreaMge/buildingMge/buildDetail/buildDetail')), 'buildDetail');
const housManageDetail = r => require.ensure([], () => r(require('@/page/housManage/housManagePage/children/housManageDetail')), 'housManageDetail');
const addOwner = r => require.ensure([], () => r(require('@/page/ownerMge/addOwner/addOwner')), 'addOwner');
const editOwner = r => require.ensure([], () => r(require('@/page/ownerMge/editOwner/editOwner')), 'editOwner');
const ownerInfo = r => require.ensure([], () => r(require('@/page/ownerMge/ownerInfo/ownerInfo')), 'ownerInfo');
const ownerTelAuth = r => require.ensure([], () => r(require('@/page/ownerMge/ownerTelAuth/ownerTelAuth')), 'ownerTelAuth');
const eaHouseReg = r => require.ensure([], () => r(require('@/page/propertyAreaMge/eaHouseReg/eaHouseReg')), 'eaHouseReg');//房屋补充业务
const eaHouseRegAccept = r => require.ensure([], () => r(require('@/page/propertyAreaMge/eaHouseRegAccept/eaHouseRegAccept')), 'eaHouseRegAccept');//房屋补充业务受理
const eaHouseRegCensor = r => require.ensure([], () => r(require('@/page/propertyAreaMge/eaHouseRegCensor/eaHouseRegCensor')), 'eaHouseRegCensor');//房屋补充业务审核
const eaHouseRegDetail = r => require.ensure([], () => r(require('@/page/propertyAreaMge/eaHouseReg/eaHouseRegDetail')), 'eaHouseRegDetail');//房屋补充业务详情
const applicationRecord = r => require.ensure([], () => r(require('@/page/propertyAreaMge/projectApproval/applicationRecord')), 'applicationRecord');//物业项目审批列表
const projectApproval = r => require.ensure([], () => r(require('@/page/propertyAreaMge/projectApproval/projectApproval')), 'projectApproval');//物业项目审批列表
const projectApprovalEareaDetails = r => require.ensure([], () => r(require('@/page/propertyAreaMge/projectApprovalEareaDetails/projectApprovalEareaDetails')), 'projectApprovalEareaDetails');//物业项目详情
const quProjectApprovalEareaDetails = r => require.ensure([], () => r(require('@/page/propertyAreaMge/projectApprovalEareaDetails/quProjectApprovalEareaDetails')), 'quProjectApprovalEareaDetails');//物业项目详情
const projectApprovalCompanyDetails = r => require.ensure([], () => r(require('@/page/propertyAreaMge/projectApprovalEareaDetails/projectApprovalCompanyDetails')), 'projectApprovalCompanyDetails');//物业服务企业申请记录详情
const setEaAreaMap = r => require.ensure([], () => r(require('@/page/propertyAreaMge/setEaAreaMap/setEaAreaMap')), 'setEaAreaMap');//落图
const propertyPersonInfoEmp = r => require.ensure([], () => r(require('@/page/propertyAreaMge/propertyPersonInfo/propertyPersonInfo')), 'propertyPersonInfoEmp');//落图
const projectApprovalAudit = r => require.ensure([], () => r(require('@/page/propertyAreaMge/projectApproval/projectApprovalAudit')), 'projectApprovalAudit');//在管物业项目审核
const propertyAreaMgeRouter = {
  path: '',
  component: propertyAreaMge,
  meta: {
    icon: 'propertyAreaMge',
    right: [],
    isShowMenu: true,
    keepAlive: false
  },
  name: '物业区域管理',
  children: [{
    path: '/queryPropertyArea',
    component: queryPropertyArea,
    name: '物业区域管理',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true,
    },
  },
  {
    path: '/addVillagesInCities',
    component: addVillagesInCities,
    name: '新增物业项目',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: false,
    },
  },
  {
    path: '/detailProoertyArea',
    component: detailProoertyArea,
    name: '物业区域',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true,
    },
  },
  {
    path: '/deletedPropertyArea',
    component: deletedPropertyArea,
    name: '项目灭失记录',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true,
    }
  },
  {
    path: '/orgProjectInfo',
    component: addOrEditOrgProject,
    name: '物业项目信息',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: true,
    }
  },
  {
    path: '/editOrEditOrgProject',
    component: editOrEditOrgProject,
    name: '物业项目信息',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: true,
    }
  },
  {
    path: '/addCompanyProperty',
    component: addCompanyProperty,
    name: '新增物业项目',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: false,
    }
  },
  {
    path: '/deleteProject',
    component: deleteProject,
    name: '删除物业项目',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: false,
    }
  },
  {
    path: '/projectAppMieShi',
    component: projectAppMieShi,
    name: '灭失详情',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: false,
    }
  },
  {
    path: '/deletedPropertyAreaSee',
    component: deletedPropertyAreaSee,
    name: '灭失详情',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: false,
    }
  },
  {
    path: '/propertyPersonInfoEmp',
    component: propertyPersonInfoEmp,
    name: '物业项目人员信息',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true,
    },
  },
  {
    path: '/buildingList',
    component: buildingList,
    name: '楼栋管理',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  },
  {
    path: '/addPropertyArea',
    component: addPropertyArea,
    name: '新增物业区域',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  },
  {
    path: '/companyList',
    component: companyList,
    name: '查看分公司项目',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: true
    },
  },
  {
    path: '/editPropertyArea',
    component: editPropertyArea,
    name: '编辑物业区域',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  }, {
    path: '/eaHouseWorkflow',
    component: eaHouseReg,
    name: '房屋补充',
    meta: {
      right: [],
      isShowMenu: true,
      workflow: true,
      workTemplateName: '房屋补充',
      keepAlive: true
    },
  }, {
    path: '/eaHouseRegAccept',
    component: eaHouseRegAccept,
    name: '房屋补充受理',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  }, {
    path: '/eaHouseRegDetail',
    component: eaHouseRegDetail,
    name: '房屋补充详情',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  }, {
    path: '/eaHouseRegCensor',
    component: eaHouseRegCensor,
    name: '房屋补充审核',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  },

  {
    path: '/eaHouseReg',
    component: eaHouseReg,
    name: '房屋补充',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: false
    },
  },
  {
    path: '/propertyRegColl',
    component: propertyRegColl,
    name: '物业区域采集',
    meta: {
      right: ['物业区域管理类业务申请'],
      isShowMenu: true,
      keepAlive: true
    },
  },
  {
    path: '/propertyInfo',
    component: propertyInfo,
    name: '物业信息',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
    children: []
  },
  {
    path: '/propertyAreaInfo',
    component: propertyAreaInfo,
    name: '物业区域信息',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: false,
      isUseCache: false,
    },
  },
  {
    path: '/editProperty',
    component: add,
    name: '项目人员信息',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: false,
      isUseCache: false,
    },
  },
  {
    path: 'houseChange',
    component: houseChange,
    name: '房屋变更',
    meta: {
      right: ['房屋过户业务申请'],
      isShowMenu: true,
      keepAlive: true
    },
  },
  {
    path: '/houseSplMer',
    component: houseSplMer,
    name: '房屋拆分合并',
    meta: {
      right: ['物业区域管理类业务申请'],
      isShowMenu: true,
      keepAlive: true
    },
  },
  {
    path: '/housManage',
    component: housManage,
    name: '房屋管理',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  },
  {
    path: '/housManageDetail',
    component: housManageDetail,
    name: '房屋管理详情',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    }
  },
  {
    path: '/housManageAdd',
    component: housManageAdd,
    name: '房屋新增',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  }, {
    path: '/housManageEdit',
    component: housManageEdit,
    name: '房屋修改',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  },
  {
    path: '/queryOwnerMge',
    component: queryOwnerMge,
    name: '业主管理',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  },
  {
    path: '/addOwner',
    component: addOwner,
    name: '添加业主信息',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  },
  {
    path: '/editOwner',
    component: editOwner,
    name: '修改业主信息',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: false
    },
  },
  {
    path: '/ownerInfo',
    component: ownerInfo,
    name: '业主详情信息',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  },
  {
    path: '/addBuilding',
    component: addBuilding,
    name: '新增楼栋',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  }, {
    path: '/editBuilding',
    component: editBuilding,
    name: '修改楼栋',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: false
    },
  },
  {
    path: '/buildDetail',
    component: buildDetail,
    name: '楼栋详情',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  },
  {
    path: '/ownerTelAuth',
    component: ownerTelAuth,
    name: '业主手机号认证',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: true
    },
  },
  {
    path: '/projectApproval',
    component: projectApproval,
    name: '申请记录',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: true
    },
  },
  {
    path: '/applicationRecord',
    component: applicationRecord,
    name: '审批列表',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: false
    },
  },
  {
    path: '/projectApprovalEareaDetails',
    component: projectApprovalEareaDetails,
    name: '项目详情',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: false
    },
  },
  {
    path: '/quProjectApprovalEareaDetails',
    component: quProjectApprovalEareaDetails,
    name: '项目详情',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: false
    },
  },
  {
    path: '/projectApprovalAudit',
    component: projectApprovalAudit,
    name: '在管项目审批',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: false
    },
  },
  {
    path: '/projectApprovalCompanyDetails',
    component: projectApprovalCompanyDetails,
    name: '项目详情',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: false
    },
  },
  {
    path: '/setEaAreaMap',
    component: setEaAreaMap,
    name: '坐标图层',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive: false
    },
  },
  ]
};

export default propertyAreaMgeRouter;
